import strict from "assert/strict";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Internal import
import "./EncuestaNoSequencial.css"
import LogoBis from "../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../common/components/MenuHeader/MenuHeader";
import TypeInputGeneratorItem from "../../../common/components/TypeInputGeneratorItem/TypeInputGeneratorItem";
import { PreguntaTipo, VisualizacionFormulario } from "../../../common/enums/AllEnums";
import { useForm } from "../../../contexts/form";
import LoadingButton from "../../../common/components/LoadingButton/LoadingButton";
import { COLORS } from "../../../common/constants/colors";
import { IFormAnswer, IFormAnswerDetail, IFormAnswerDetailOption } from "../../../interfaces/IAnswer";
import { IFormQuestionOption } from "../../../interfaces/IForm";
import { openNotification, tryCatch } from "../../../common/constants/Utilities";
import { ActiveFormListDetailByFormID, ActiveOrBlockFormListDetail, InsertFormAnswered } from "../../../services/survey";
import PreventLeavePageItem from "../../../common/components/PreventLeavePageItem/PreventLeavePageItem";
import { IEntitySurvey } from "../../../interfaces/IEntitySurvey";
import ConfirmationModal from "../../../common/components/Modal/CorfimationModal";

const EncuestaNoSequencial = () => {
  const [answerValue, SetAnswerValue] = useState<any>({});
  const { questionForm, entitySurveySelected } = useForm();
  const [listValidations, SetListValidations] = useState<{ id: number, validation: { typeValidation: string, valor: any }[] }[]>([]);
  const [isLast, setIsLast] = useState<boolean>(false);
  const [enableButton, setEnableButton] = useState<boolean>(false);
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [group, setGroup] = useState<string[]>([]);
  const [listaErrores, setListaErrores] = useState<any[]>([])
  const navigate = useNavigate();

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [loadingAction, setLoadingAction] = useState<boolean>(false);

  const desbloquearEntidad = (entityToSurvey: IEntitySurvey) => {
    setLoadingAction(true)
    if (questionForm?.visualizacionTipoNombre !== VisualizacionFormulario.Tabla) {
      tryCatch(() => {
        if (questionForm?.bloquearPaginacion) {
          if (questionForm.visualizacionTipoNombre === VisualizacionFormulario.ListadoDetalle && JSON.parse(localStorage.getItem('GoBackConfirmed') || 'null')) {

          } else {
            ActiveFormListDetailByFormID(questionForm.formularioID)
              .then((response) => {})
              .catch((response) => {
                openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
              })
              .finally(() => {
                setDeleteModal(false);
                setLoadingAction(false);
              });
          }

        } else {
          ActiveOrBlockFormListDetail(entityToSurvey?.formularioListadoDetalleID!, false)
            .then((response) => {})
            .catch((response) => {
              openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
            })
            .finally(() => {
              setDeleteModal(false);
              setLoadingAction(false);
            });
        }

      })
    }
  }

  const asignQuestion = () => {
    const listrespuesta: IFormAnswerDetail[] = [];
    //console.log(listrespuesta, "listrespuesta")

    let answerDetail: IFormAnswerDetail;

    let answerOption: IFormAnswerDetailOption[] = [];

    questionForm!.pregunta.forEach(pregunta => {

        const result = answerValue[pregunta.preguntaID];

        if (pregunta.preguntaTipoNombre == PreguntaTipo.SeleccionMultiple || pregunta.preguntaTipoNombre == PreguntaTipo.Seleccion) {
            answerOption = [];
            if (!!result)
            {
                result.split("|").map((valor: any) => {
                    var opcion = pregunta.respuestaOpcion.find(item => item.respuesta == valor);
                    const _respuestaOpcion: IFormAnswerDetailOption = {
                        respuestaDetalleID: 0,
                        respuestaOpcionID: opcion?.respuestaOpcionID!,
                        respuesta: valor,
                        resultado: opcion?.resultado!
                    };
                    answerOption.push(_respuestaOpcion);    
                })
            }   
            else
            {
                const _respuestaOpcion: IFormAnswerDetailOption = {
                    respuestaDetalleID: 0,
                    respuestaOpcionID: null,
                    respuesta: null,
                    resultado: null
                };
                answerOption.push(_respuestaOpcion);
            }                 
        } else if (pregunta.preguntaTipoNombre == PreguntaTipo.FechaRangoMultiple) {
            answerOption = [];
            if (!!result)
            {
                result.split("|").map((valor: any) => {
                    const _respuestaOpcion: IFormAnswerDetailOption = {
                        respuestaDetalleID: 0,
                        respuestaOpcionID: pregunta.respuestaOpcion[0].respuestaOpcionID,
                        respuesta: valor,
                        resultado: pregunta.respuestaOpcion[0].resultado
                    };
                    answerOption.push(_respuestaOpcion);    
                })
            }
            else
            {
                const _respuestaOpcion: IFormAnswerDetailOption = {
                    respuestaDetalleID: 0,
                    respuestaOpcionID: pregunta.respuestaOpcion[0].respuestaOpcionID,
                    respuesta: null,
                    resultado: pregunta.respuestaOpcion[0].resultado
                };
                answerOption.push(_respuestaOpcion);
            }                
        } else {
            answerOption = [];
            const _respuestaOpcion: IFormAnswerDetailOption = {
                respuestaDetalleID: 0,
                respuestaOpcionID: pregunta.respuestaOpcion[0].respuestaOpcionID,
                respuesta: !!result ? result : null,
                resultado: pregunta.respuestaOpcion[0].resultado
            };
            answerOption.push(_respuestaOpcion);
        }

        answerDetail = {
            respuestaDetalleID: 0,
            respuestaID: 0,
            grupoPreguntaID: pregunta?.grupoPreguntaID!,
            preguntaID: pregunta?.preguntaID!,
            grupo: pregunta?.grupoPreguntaNombre!,
            grupoOrden: pregunta?.grupoPreguntaOrden!,
            pregunta: pregunta?.preguntas!,
            preguntaTipo: pregunta?.preguntaTipo!,
            preguntaTipoNombre: pregunta?.preguntaTipoNombre!,
            preguntaOrden: pregunta?.orden!,
            respuestaOpcion: answerOption,
        }

        listrespuesta.push(answerDetail);
    })

    let formuAnsuwer: IFormAnswer = ({
        respuestaID: 0,
        sistemaOrigen: 'BisFormularioWeb',
        formularioID: questionForm!.formularioID,
        usuarioLatitud: null,
        usuarioLongitud: null,
        formularioListadoDetalleID: entitySurveySelected?.formularioListadoDetalleID!,
        respuesta: listrespuesta
    });
    //guarda Formulario
    saveAnswer(formuAnsuwer);
}

  const validationXQuestion = (PreguntaID: number) => {
    const validacionObj: { typeValidation: string, valor: any }[] = [];
    const item = questionForm?.pregunta.find(x => x.preguntaID === PreguntaID);
    if (!!item) {

        if (item.esObligatoria) {
            validacionObj.push({ ...validacionObj, typeValidation: 'Required', valor: '' })
        }

        if (item.preguntaTipoNombre === PreguntaTipo.Fecha || item.preguntaTipoNombre === PreguntaTipo.FechaHora || item.preguntaTipoNombre === PreguntaTipo.Hora) {
            if (item.valorMinimo! !== null) {
                validacionObj.push({ ...validacionObj, typeValidation: 'Min', valor: item.valorMinimo! })
            }
            if (item.valorMaximo! !== null) {
                validacionObj.push({ ...validacionObj, typeValidation: 'Max', valor: item.valorMaximo! })
            }
        }
        if (item.preguntaTipoNombre === PreguntaTipo.Numerico) {
            if (item.valorMinimo! > 0) {
                validacionObj.push({ ...validacionObj, typeValidation: 'Min', valor: item.valorMinimo! })
            }
            if (item.valorMaximo! > 0) {
                validacionObj.push({ ...validacionObj, typeValidation: 'Max', valor: item.valorMaximo! })
            }
        }

    }
    return validacionObj;
};

  const convalidarErrores = () => {
    let listErrores: any[] = [];
    questionForm?.pregunta.map(pregu => {

        if (lookForError(pregu.preguntaID, answerValue[pregu.preguntaID], pregu.preguntaTipoNombre).length !== 0) {
            listErrores.push(lookForError(pregu.preguntaID, answerValue[pregu.preguntaID], pregu.preguntaTipoNombre))
        }
    }
    )
    setListaErrores(listErrores);
    listErrores.length > 0 ? setIsLast(false) : setIsLast(true);
}

  const lookForError = (preguntaId: number, value: string, preguntaTipo: PreguntaTipo) => {
    let errorText = '';
    const currentQuestion = listValidations.find(x => x.id === preguntaId);
    currentQuestion?.validation.forEach(x => {
        if (x.typeValidation == 'Required' && !value) {
            errorText = 'Requerido';
            return;
        }
        if (preguntaTipo === PreguntaTipo.Numerico) {
            if (x.typeValidation == 'Min' && parseInt(value) < x.valor) {
                errorText = 'El minimo es ' + x.valor;
                return;
            }
            if (x.typeValidation == 'Max' && parseInt(value) > x.valor) {
                errorText = 'El máximo es ' + x.valor;
                return;
            }
        }
        if (preguntaTipo === PreguntaTipo.Fecha) {
            const date: Date = new Date(value);
            const DateDef: Date = new Date(x.valor);
            if (x.typeValidation == 'Min' && new Date(date.setDate(date.getDate() + 1)) < DateDef) {
                errorText = 'El minimo es ' + (x.valor);
                return;
            }
            if (x.typeValidation == 'Max' && date > DateDef) {
                errorText = 'El máximo es ' + (x.valor);
                return;
            }
        }
        if(preguntaTipo === PreguntaTipo.FechaHora){
            const date: Date = new Date(value);
            const DateDef: Date = new Date(x.valor);
            if (x.typeValidation == 'Min' && date < DateDef) {
                errorText = 'El minimo es ' + (x.valor);
                return;
            }
            if (x.typeValidation == 'Max' && date > DateDef) {
                errorText = 'El máximo es ' + (x.valor);
                return;
            }
        }
        if (preguntaTipo === PreguntaTipo.Hora) {
            const DateDef: Date = new Date(x.valor);
            const hora = DateDef.toLocaleTimeString('en-UK')
            if(x.typeValidation == 'Min' && value < hora){
                errorText = 'El minimo es ' + (hora)
            }
            if(x.typeValidation == 'Max' && value > hora) {
                errorText = 'El maximo es ' + (hora)
            }
        }
        if (preguntaTipo === PreguntaTipo.Archivo) {

            try {
                const parsedValue = JSON.parse(value)
                const fileType = parsedValue.type;
                const isExcelOrPdf  =
                    fileType === 'application/vnd.ms-excel' ||
                    fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                    fileType === 'application/pdf';

                if (!isExcelOrPdf) {
                    errorText = 'Solo se permiten archivos Excel o PDF.'
                }
            } catch (e) {
                errorText = 'Solo se permiten archivos Excel o PDF.'
            }
        }
        if (preguntaTipo === PreguntaTipo.Galeria || preguntaTipo === PreguntaTipo.CamaraGaleria || preguntaTipo === PreguntaTipo.Imagen) {
            try {
                const parsedValue = JSON.parse(value)
                const fileType = parsedValue.type;
                const isImage  =
                    fileType === 'image/jpeg' ||
                    fileType === 'image/png' ||
                    fileType === 'image/gif';

                if (!isImage) {
                    errorText = 'Solo se permiten archivos de imagen (JPEG, PNG, GIF).'
                }
            } catch (e) {
                errorText = 'Solo se permiten archivos de imagen (JPEG, PNG, GIF).'
            }
        }
    });

    return errorText;
}


  const onSubmit = () => { asignQuestion(); };

  const handleSetQuestionValue = (value: any, preguntaID: number) => {
    let cloneValue: any = { ...answerValue };
    cloneValue[preguntaID] = value;
    SetAnswerValue(cloneValue);
  }

  const saveAnswer = (_formuAnsuwer: IFormAnswer) => {
    tryCatch(() => {
      setFormLoading(true);
      InsertFormAnswered(_formuAnsuwer!)
        .then((response) => {
          openNotification('success', 'Guardar', response.msg!);
          localStorage.setItem('CheckLeave', JSON.stringify(false));
          navigate(`/bisformulario/encuesta`);
        })
        .catch((response) => {
          openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
        })
        .finally(() => setFormLoading(false));
    })
  }

  useEffect(() => {
    SetListValidations(questionForm!.pregunta?.map(pregunta => ({
      id: pregunta.preguntaID,
      validation: validationXQuestion(pregunta.preguntaID)
    })));
    localStorage.setItem('CheckLeave', JSON.stringify(true));
  }, []);

  useEffect(() => {
    listaErrores.length ? setEnableButton(true) : setEnableButton(false);
  }, [listaErrores]);

  useEffect(() => { convalidarErrores() }, [answerValue, listValidations]);

  useEffect(() => {
    const groupList: string[] = [];
    questionForm?.pregunta.map(grupoNombre => grupoNombre.grupoPreguntaNombre!).forEach(item => {
      if (!groupList.includes(item)) {
        groupList.push(item);
      }
    });
    setGroup(groupList);
  }, [questionForm?.pregunta]);

  return (
    <div>
      <div className={"nav_header"}>
        <LogoBis />
        <MenuHeader currentPage={questionForm?.nombre!} clientCode={questionForm?.visualizacionTipoNombre !== VisualizacionFormulario.Tabla ? (entitySurveySelected?.nombre + " : " + entitySurveySelected?.codigo) : ""} isMenu={false} />
      </div>

      <div className="Nosecuencial">
        {questionForm?.pregunta.map((pregunta, index) => (
          !pregunta.grupoPreguntaNombre &&
          <div key={pregunta.preguntaID} className="caja">
            <div className="Nosecuencial-header">
              <h3>{pregunta?.grupoPreguntaNombre}</h3>
              <h1>{pregunta?.preguntas}</h1>
            </div>
            <TypeInputGeneratorItem active={false} value={pregunta?.preguntaTipoNombre} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} isDraggable={true} />
            <p className="ContainerBox-body-middle-error">{lookForError(pregunta.preguntaID, answerValue[pregunta.preguntaID], pregunta.preguntaTipoNombre)}</p>
          </div>
        ))}

        {group.map(nombregrupo => (
          <div key={nombregrupo}>
            <h3 className="groupName">{nombregrupo}</h3>
            {questionForm?.pregunta.map(pregunta => (
              !!pregunta.grupoPreguntaNombre?.includes(nombregrupo) &&
              <div key={pregunta.preguntaID} className="caja">
                <div className="Nosecuencial-header">
                  <h1>{pregunta?.preguntas}</h1>
                </div>
                <TypeInputGeneratorItem active={false} value={pregunta?.preguntaTipoNombre} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} isDraggable={true} />
                <p className="ContainerBox-body-middle-error">{lookForError(pregunta.preguntaID, answerValue[pregunta.preguntaID], pregunta.preguntaTipoNombre)}</p>
              </div>
            ))}
          </div>
        ))}

        <div className="ContainerBox-footer">
          <LoadingButton
            disabled={enableButton}
            type="button"
            title={"Enviar respuesta"}
            style={{ height: '50px', width: '350px' }}
            background={COLORS.blue_active}
            color={COLORS.white_color1}
            loading={formLoading.toString()}
            method={() => onSubmit()}
            fontsize={18}
          />
        </div>
      </div>

      <PreventLeavePageItem
        message="¿Desea abandonar la presente página?"
        when={JSON.parse(localStorage.getItem('CheckLeave') || 'null')}
        method={() => desbloquearEntidad(entitySurveySelected!)}
      />
    </div>
  )
}

export default EncuestaNoSequencial;
